// import "../styles/Manifacturing.css";

// export default function Manufacturing() {
//   return (
//     <section className="manufacturing-section">

//       <div className="container">

//         {/* HEADER */}
//         <div className="manufacturing-header">

//           <h2>Manufacturing Capabilities</h2>

//           <p>
//             Advanced in-house engineering and production facilities
//             ensuring precision, quality, and global standards.
//           </p>

//         </div>

//         {/* GRID */}
//         <div className="manufacturing-grid">

//           <div className="manufacturing-card">❄ Outdoor & Indoor Unit Assembly with Galileo-Inficon Equipment</div>

//           <div className="manufacturing-card">⚙ Turret Punching, Press Brake & Fabrication</div>

//           <div className="manufacturing-card">🎨 In-House Powder Coating Paint Shop (GEMA Germany)</div>

//           <div className="manufacturing-card">🧪 ELT Laboratory Testing Facility</div>

//           <div className="manufacturing-card">📐 NX Software for 2D & 3D Designing</div>

//           <div className="manufacturing-card">🏭 Sheet Metal Pressing with JAT Group Plant K-10</div>

//           <div className="manufacturing-card">🔧 Tool Room Facility (30 Years Experience)</div>

//           <div className="manufacturing-card">⚡ High Precision AC Assembly Lines</div>

//           <div className="manufacturing-card">🧊 HVAC System Manufacturing Setup</div>

//           <div className="manufacturing-card">🔩 CNC Based Fabrication Units</div>

//           <div className="manufacturing-card">📦 OEM Production & Supply Chain Support</div>

//           <div className="manufacturing-card">🌍 Global Brand Manufacturing Support</div>

//         </div>

//       </div>

//     </section>
//   );
// }























// import "../styles/Manifacturing.css";

// export default function Manufacturing() {
//   return (
//     <section className="manufacturing-section">

//       <div className="container">

//         {/* HEADER */}
//         <div className="manufacturing-header">

//           <h2>Manufacturing Capabilities</h2>

//           <p>
//             Advanced in-house engineering and production facilities
//             ensuring precision, quality, and global standards.
//           </p>

//         </div>

//         {/* GRID */}
//         <div className="manufacturing-grid">

//           <div className="manufacturing-card">
//             ❄ Outdoor & Indoor Unit Assembly with Galileo-Inficon Equipment
//           </div>

//           <div className="manufacturing-card">
//             ⚙ Turret Punching, Press Brake & Fabrication
//           </div>

//           <div className="manufacturing-card">
//             🎨 In-House Powder Coating Paint Shop (GEMA Germany)
//           </div>

//           <div className="manufacturing-card">
//             🧪 ELT Laboratory Testing Facility
//           </div>

//           <div className="manufacturing-card">
//             📐 NX Software for 2D & 3D Designing
//           </div>

//           <div className="manufacturing-card">
//             🏭 Sheet Metal Pressing with JAT Group Plant K-10
//           </div>

//           <div className="manufacturing-card">
//             🔧 Tool Room Facility (30 Years Experience)
//           </div>

//           <div className="manufacturing-card">
//             ⚡ High Precision AC Assembly Lines
//           </div>

//           <div className="manufacturing-card">
//             🧊 HVAC System Manufacturing Setup
//           </div>

//           <div className="manufacturing-card">
//             🔩 CNC Based Fabrication Units
//           </div>

//           <div className="manufacturing-card">
//             📦 OEM Production & Supply Chain Support
//           </div>

//           <div className="manufacturing-card">
//             🌍 Global Brand Manufacturing Support
//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }













import "../styles/Manifacturing.css";

export default function Manufacturing() {
  return (
    <section className="manufacturing-section">

      <div className="container">

        {/* HEADER */}
        <div className="manufacturing-header">

          <h2>Manufacturing Capabilities</h2>

          <p>
            Advanced in-house engineering and production facilities
            ensuring precision, quality, and global standards.
          </p>

        </div>

        {/* GRID */}
        <div className="manufacturing-grid">

          <div className="manufacturing-card">
            <span className="card-icon">❄</span>
            <p>Outdoor & Indoor Unit Assembly with Galileo-Inficon Equipment</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">⚙</span>
            <p>Turret Punching, Press Brake & Fabrication</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🎨</span>
            <p>In-House Powder Coating Paint Shop (GEMA Germany)</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🧪</span>
            <p>ELT Laboratory Testing Facility</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">📐</span>
            <p>NX Software for 2D & 3D Designing</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🏭</span>
            <p>Sheet Metal Pressing with JAT Group Plant K-10</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🔧</span>
            <p>Tool Room Facility (30 Years Experience)</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">⚡</span>
            <p>High Precision AC Assembly Lines</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🧊</span>
            <p>HVAC System Manufacturing Setup</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🔩</span>
            <p>CNC Based Fabrication Units</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">📦</span>
            <p>OEM Production & Supply Chain Support</p>
          </div>

          <div className="manufacturing-card">
            <span className="card-icon">🌍</span>
            <p>Global Brand Manufacturing Support</p>
          </div>

        </div>

      </div>

    </section>
  );
}